import React from "react";

import {
  WizardStepperWrapperProps,
  WizardStepperStep as StepType
} from "../types";
import { Step } from "./Step";
import * as S from "./StepperWrapper.styles";

/**
 * Container component for the wizard steps
 */
export const StepperWrapper = ({
  steps,
  hasLabel,
  onStepClick
}: WizardStepperWrapperProps) => {
  const handleStepClick = (step: StepType) => {
    if (onStepClick) {
      onStepClick(step);
    }
  };

  return (
    <S.WizardStepperWrapper>
      {steps.map((step, index) => {
        return (
          <React.Fragment key={step.number}>
            <Step
              hasLabel={hasLabel}
              step={step}
              onClick={() => handleStepClick(step)}
            />
            {steps.length - 1 !== index && <S.StepSeparator />}
          </React.Fragment>
        );
      })}
    </S.WizardStepperWrapper>
  );
};
